<template>
  <component :is="addressComponent" :storageKey="storageKey"></component>
</template>

<script>

export default {
  components: {

  },
  props: ['storageKey'],
  data: () => ({
    addressComponent: null
  }),
  mounted () {
    this.loadComponent()
  },
  computed: {

  },
  methods: {
    loadComponent() {
      let ianaCode = this.$store.state.app.locale.code;
      ianaCode = ianaCode.substring(3, 5);

      this.addressComponent = () => import('@/packages/Address/src/resources/components/' + ianaCode + '_AddressForm.vue');
    }
  }
}
</script>

<style scss>

</style>
